import { render, staticRenderFns } from "./ucusdetay.vue?vue&type=template&id=53272a00"
import script from "./ucusdetay.vue?vue&type=script&lang=js"
export * from "./ucusdetay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports